/*
 * Tank-style premium transitions for Treasured Scents.
 * Section-by-section reveals: each section fades + rises as a cohesive unit,
 * with its inner elements cascading in a refined stagger.
 * Vanilla IntersectionObserver — no libs, plays nice with Shopify + theme editor.
 */
(function () {
  'use strict';

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Inner elements within a section that cascade
  var CHILD_SELECTOR = [
    'h1', 'h2', 'h3', 'h4',
    'p',
    '.button', 'a.button',
    '.product-card', '.card', '.collection-card',
    '.tank-service',
    '.media-with-content__media', '.media-with-content__content',
    'img'
  ].join(',');

  function markSection(section) {
    if (section.dataset.tankSection) return;
    section.dataset.tankSection = '1';
    section.classList.add('tank-section');

    // tag a limited set of children for cascade (avoid over-tagging huge grids)
    var kids = Array.prototype.slice.call(section.querySelectorAll(CHILD_SELECTOR));
    // de-dupe nested (only top-most meaningful blocks) and cap for performance
    var tagged = 0;
    kids.forEach(function (el) {
      if (tagged >= 14) return;
      // never tag carousel slides — the reveal forces opacity:1 and would break the
      // hero slideshow (all slides would stack visible / look static)
      if (el.closest('.tank-hero__carousel')) return;
      // never tag content inside drawers/dialogs/cart — they aren't in the scroll
      // flow, so the IntersectionObserver never fires to reveal them, leaving the
      // content stuck at opacity:0 (e.g. the empty cart drawer showed as a black panel).
      if (el.closest('theme-drawer, dialog, cart-drawer-component, #cart-drawer, .cart-drawer__inner, .theme-drawer__dialog, .header, #header-group')) return;
      // skip if an ancestor within the section is already tagged (keep it cohesive)
      if (el.closest('.tank-child') && el.closest('.tank-child') !== el) return;
      el.classList.add('tank-child');
      tagged++;
    });
  }

  function reveal(section) {
    section.classList.add('tank-section--in');
    var kids = section.querySelectorAll('.tank-child');
    Array.prototype.forEach.call(kids, function (el, i) {
      el.style.transitionDelay = Math.min(i * 45, 270) + 'ms';
    });
  }

  function init(root) {
    root = root || document;
    if (prefersReduced() || !('IntersectionObserver' in window)) {
      // show everything immediately
      Array.prototype.forEach.call(
        (root).querySelectorAll('.shopify-section'),
        function (s) { s.classList.add('tank-section--in'); }
      );
      return;
    }

    var sections = Array.prototype.slice.call(root.querySelectorAll('.shopify-section'));
    sections.forEach(markSection);

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px 18% 0px' });

    sections.forEach(function (s) {
      // header/footer groups + the hero should show immediately (above the fold)
      if (s.closest('.shopify-section-group-header-group') ||
          s.querySelector('.tank-hero') ||
          s.getBoundingClientRect().top < window.innerHeight * 0.85) {
        s.classList.add('tank-section--in');
      } else {
        io.observe(s);
      }
    });
  }

  function boot() { init(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    // re-init a re-rendered section in the editor
    markSection(e.target);
    reveal(e.target);
  });
})();
